var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4231 18.625H12.923V17.625H14.1731C14.3859 17.625 14.5641 17.5532 14.7077 17.4096C14.8513 17.266 14.923 17.0878 14.923 16.875V13.875C14.923 13.6622 14.8513 13.484 14.7077 13.3404C14.5641 13.1968 14.3859 13.125 14.1731 13.125H10.923V11.625H14.923V10.125H12.923V9.12498H11.4231V10.125H10.1731C9.96026 10.125 9.78205 10.1968 9.63845 10.3404C9.49487 10.484 9.42308 10.6622 9.42308 10.875V13.875C9.42308 14.0878 9.49487 14.266 9.63845 14.4096C9.78205 14.5532 9.96026 14.625 10.1731 14.625H13.4231V16.125H9.42308V17.625H11.4231V18.625ZM6.3077 21.5C5.80257 21.5 5.375 21.325 5.025 20.975C4.675 20.625 4.5 20.1974 4.5 19.6923V4.3077C4.5 3.80257 4.675 3.375 5.025 3.025C5.375 2.675 5.80257 2.5 6.3077 2.5H14.25L19.5 7.74995V19.6923C19.5 20.1974 19.325 20.625 18.975 20.975C18.625 21.325 18.1974 21.5 17.6922 21.5H6.3077ZM13.5 7.88458V3.99998H6.3077C6.23077 3.99998 6.16024 4.03203 6.09612 4.09613C6.03202 4.16024 5.99997 4.23077 5.99997 4.3077V19.6923C5.99997 19.7692 6.03202 19.8397 6.09612 19.9038C6.16024 19.9679 6.23077 20 6.3077 20H17.6922C17.7692 20 17.8397 19.9679 17.9038 19.9038C17.9679 19.8397 18 19.7692 18 19.6923V7.88458H13.5Z",
    fill: "black",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentRequest);
export default __webpack_public_path__ + "static/media/PaymentRequest.0cd269d2f8c8d89a943d87d6786b50e4.svg";
export { ForwardRef as ReactComponent };